import { twMerge } from 'tailwind-merge';

import { useClientHasRendered } from '../../../../helpers/hooks';
import { Button } from '../../../Clickables/Buttons/Button';

interface IProps {
  className: string;
  onDownloadAppClick: () => void;
}

export const CommentCTA = ({ className, onDownloadAppClick }: IProps) => {
  const hasClientRendered = useClientHasRendered();

  return hasClientRendered ? (
    <div className={twMerge('body-text-md', className)}>
      <Button
        variant="textNone"
        onClick={onDownloadAppClick}
        className="font-semibold text-tuna-shade"
      >
        Get the Fishbrain app
      </Button>{' '}
      to comment
    </div>
  ) : (
    <></>
  );
};
